import $ from 'jquery';

const defaults = {
  selector: '#next_video',
};

function NextVideo(element, options) {
  this.$element = $(element);
  this.settings = { ...defaults, ...options };
  this.click = $.proxy(this.click, this);
  this.listen();
}

NextVideo.prototype = {
  listen() {
    this.$element.find(this.settings.selector).on('click', this.click);
  },
  click() {
    $(this.$element.find('.slick-next')).click();
    return false;
  },
};

export default NextVideo;



// WEBPACK FOOTER //
// ./NextVideo.js